import type { CheckoutSkiAncillaryServiceOption } from '../../../domain/types';

export const getDaysRangeFormatted = (start: string, end: string, locale: string) => {
  const newStartDate = new Date(start);
  const newEndDate = new Date(end);
  const startDayName = newStartDate.toLocaleString(locale, { weekday: 'long' });
  const newEndDayName = newEndDate.toLocaleString(locale, { weekday: 'long' });

  return { startDay: startDayName, endDay: newEndDayName}
};

export const getPriceDifferenceAndPriceSymbol = (selectedValue: string | null, price: number, options: Record<string, CheckoutSkiAncillaryServiceOption>, participantAgeCategory?: string) => {
  const { priceBreakdown = [] } = selectedValue ? options[selectedValue] : {};
  let priceDifference = price;
  if (priceBreakdown && priceBreakdown.length > 0) {
    priceDifference = price - (priceBreakdown?.find(({ageCategory}) => ageCategory === participantAgeCategory)?.price ?? 0);
  }
  if (!priceBreakdown && selectedValue) {
    priceDifference = price - options[selectedValue].price;
  }

  let priceSymbol = '';

  if (priceDifference > 0) {
    priceSymbol = '+';
  }
  if (priceDifference < 0) {
    priceSymbol = '-';
  }
  return { priceDifference, priceSymbol };
};
